
import {mapActions} from "vuex";

export default {
  name: "toolSoftwaresPop",
  props:['list'],
  data() {
    return {

    }
  },
  methods:{
    ...mapActions(['setSmproApp']),
    goToPage(link) {
      this.$parent.menuHide = true;
      if (!location.pathname.includes(link)) {
        this.$router.push({path: link});
      }
      setTimeout(() => {
        this.$parent.menuHide = false;
      }, 100)
    }
  }
}
